'use client';

import { LoginForm } from '../login/ui/login-form';
import { useAuthFlowStore } from '../model/use-auth-flow-store';
import RegisterForm from '../register/ui/register-form';

type Props = {
  onSuccess: () => void;
};

export const AuthSteps: React.FC<Props> = ({ onSuccess }) => {
  const { step } = useAuthFlowStore();

  if (step === 'login') {
    return <LoginForm onSuccess={onSuccess} />;
  }

  if (step === 'register') {
    return <RegisterForm onSuccess={onSuccess} />;
  }
};
